import {
  Input as AntdInput,
  InputProps as AntdInputProps,
  Typography,
} from "antd";
import React from "react";
import { v4 as uuid } from "uuid";
import * as styles from "./Input.css";

interface InputProps extends AntdInputProps {
  label?: string;
}
const Input = ({
  id = `accessible-antd-input-${uuid()}`,
  label,
  ...props
}: InputProps) => {
  return (
    <div>
      {label ? (
        <label htmlFor={id}>
          <Typography.Text strong style={{ marginBottom: "8px" }}>
            {label}
          </Typography.Text>
        </label>
      ) : null}
      <AntdInput
        aria-describedby={`description-${id}`}
        aria-labelledby={id}
        className={styles.customAntInput}
        id={id}
        {...props}
      />
    </div>
  );
};

Input.Password = AntdInput.Password;
Input.Search = AntdInput.Search;
Input.TextArea = AntdInput.TextArea;

export default Input;
